// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyDHqZsfStaxvmAi15isQ_2-9libGObz1T4",
    authDomain: "tapak-admin.firebaseapp.com",
    databaseURL: "https://tapak-admin-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "tapak-admin",
    storageBucket: "tapak-admin.appspot.com",
    messagingSenderId: "402165801589",
    appId: "1:402165801589:web:ec6f913a738bfc1e4e4e3c",
    measurementId: "G-L9PL2SPN1P"
  };

  export default firebaseConfig;